<template>
  <div>
    <input
      type="file"
      data-file="image"
      accept="image/jpeg, image/png"
      class="form-control"
      :placeholder="input.placeholder"
      :required="!input.optional"
      :disabled="input.disabled"
      :name="input.name"
      @change="(e) => handleChange(e)"
      :id="inputId"
    />
    <a
      class="upload-image"
      @click="handleClick"
      :style="
        input.thisValue
          ? 'background-image:url(' + input.thisValue.replace(/ /g, '%20') + ')'
          : thisValue
          ? 'background-image:url(' + thisValue.replace(/ /g, '%20') + ')'
          : input.value
          ? 'background-image:url(' + input.value.replace(/ /g, '%20') + ')'
          : ''
      "
    >
      <i class="material-symbols-outlined">image</i>
    </a>
  </div>
</template>

<script>
export default {
  name: "UploadImage",
  components: {
    // UploadFile,InputText
  },
  props: {
    input: Object,
    value: String,
  },
  data: function() {
    ////console.log(this.value);
    return {
      thisValue: this.value,
      inputId: this.input.name + Math.random(10),
    };
  },
  methods: {
    handleChange(e) {
      ////console.log(e);
      ////console.log(e.target.files[0].path);
      let self = this;
      if (e.target.files && e.target.files[0]) {
        var reader = new FileReader();

        reader.onload = function(e) {
          self.thisValue = e.target.result;
        };

        reader.readAsDataURL(e.target.files[0]);
      }
      this.$emit("handleChange", e);
    },
    handleClick() {
      document.getElementById(this.inputId).click();
    },
  },
  mounted() {
    this.$forceUpdate();
  },
};
</script>
<style>
.form-group.upload-file-group .upload-file .upload-file-body {
  padding: 0.5rem 0.25rem !important;
}
.form-group.upload-file-group .upload-file {
  border: 1px solid rgba(0, 7, 51, 0.16);
}
input.link {
  padding-left: 1.75rem;
}
</style>
